import { i18nProvider } from '~/App';

export interface Categories {
  business: string[];
  individual: string[];
  partner: string[];
  other: string[];
}

export const categorizeFeatures = (features: string[]) => {
  const categories: Categories = {
    business: [] as string[],
    individual: [] as string[],
    partner: [] as string[],
    other: [] as string[],
  };

  features.forEach((feature) => {
    if (feature.startsWith('veengu_business_')) {
      categories.business.push(feature);
    } else if (feature.startsWith('veengu_individual_')) {
      categories.individual.push(feature);
    } else if (feature.startsWith('veengu_partner')) {
      categories.partner.push(feature);
    } else {
      categories.other.push(feature);
    }
  });

  return categories;
};

export const businessRoles = [
  'BUSINESS_SALES_AGENT',
  'BUSINESS_ADMINISTRATOR',
  'BUSINESS_MANAGER',
  'BUSINESS_CASHIER',
];

export const l = (key: string): string => `resources.solutions.${key}`;

export const validateInteger = (value: number) => {
  return value == null || Number.isInteger(value)
    ? undefined
    : i18nProvider.translate(l('featuresConfig.mustBeInteger'), {});
};
